// extracted by mini-css-extract-plugin
module.exports = {"upgradeBackground":"paywall_upgrade_section-module__upgradeBackground___7Rla8","premiumPlanText":"paywall_upgrade_section-module__premiumPlanText___kE3LZ"};